/**
 * @Des 新增/编辑 车辆 弹出层
 * @Auth
 * @Date 2021/6/19
 */

/* HTML */
<template>
    <div v-if="dialogForm.dialogFormVisible">
    	<el-dialog :title="dialogForm.title"
	               :visible.sync="dialogForm.dialogFormVisible"
	               :close-on-click-modal="false"
	               custom-class="form-dialog"
	               v-dialogDrag
	               class="dialog_title"
	               @close="handleDialogClose"
	    >

	        <el-form  label-width="130px" ref="dialogRowForm" :rules="rules" :model="dialogRowForm">
	            <el-form-item class="inline-block row-items-2" label="车辆组名：" prop="groupId">
                    <div v-if="dialogForm.optionType == optionType.binding || this.dialogForm.optionType == optionType.unbound">
                        <el-input v-model="dialogRowForm.groupName" disabled class="rt-input"/>
                    </div>
                    <div v-else>
                        <TreeSelect :data="carGroups" :selectTree="groupSelectTree" @setSelectVal="setSelectVal" ref="treeSelect"/>
                    </div>
	            </el-form-item>
	            <el-form-item class="inline-block row-items-2" label="车辆类型：" prop="carType">
	                <div v-if="dialogForm.optionType == optionType.edit || dialogForm.optionType == optionType.binding || this.dialogForm.optionType == optionType.unbound">
	                    <el-input v-model="dialogRowForm.carType" disabled class="rt-input"/>
	                </div>
	                <div v-else>
                        <el-input v-model="dialogRowForm.carType" clearable/>
	                </div>
	            </el-form-item>
	            <el-form-item class="inline-block row-items-2" label="车牌号：" prop="carNumber">
	                <div v-if="dialogForm.optionType == optionType.edit || dialogForm.optionType == optionType.binding || this.dialogForm.optionType == optionType.unbound">
	                    <el-input v-model="dialogRowForm.carNumber" disabled class="rt-input"/>
	                </div>
	                <div v-else>
					            <el-input v-model="dialogRowForm.carNumber" clearable/>
	                </div>
	            </el-form-item>
	            <el-form-item class="inline-block row-items-2" label="司机：" prop="userId">
	                <div v-if="dialogForm.optionType == optionType.add || this.dialogForm.optionType == optionType.edit">
	                    <el-select v-model="dialogRowForm.userId" clearable filterable>
	                        <el-option
	                            v-for="item in users"
	                            :key="item.userId"
	                            :label="item.idCard + '：' + item.userName"
	                            :value="item.userId">
	                        </el-option>
	                    </el-select>
	                </div>
	                <div v-else>
                        <el-select v-model="dialogRowForm.userId" disabled class="rt-input">
                            <el-option
                                v-for="item in users"
                                :key="item.userId"
                                :label="item.idCard + '：' + item.userName"
                                :value="item.userId">
                            </el-option>
                        </el-select>
	                </div>
	            </el-form-item>
	            <el-form-item class="inline-block row-items-2" label="绑定标签号(选择或刷卡)：" prop="tagId">
	            	<label slot="label"><div style="line-height: 26px;">绑定标签号</div><div style="line-height: 20px;">(选择或刷卡)</div></label>
	                <div v-if="dialogForm.optionType == optionType.edit">
	                    <el-input v-model="dialogRowForm.tagId" disabled class="rt-input"/>
	                </div>
	                <div v-else>
	                    <el-select v-model="dialogRowForm.tagId" clearable filterable @change="searchTagCar" >
	                        <el-option
	                            v-for="item in unBoundTagIds"
	                            :key="item.did"
	                            :label="item.did + '（ ' + item.sid + ' ）'"
	                            :value="item.did">
	                        </el-option>
	                    </el-select>
	                </div>
	            </el-form-item>
	            <el-form-item v-if="false" class="inline-block row-items-2" label="作业区域：" prop="zoneOfAction">
	                <div v-if="dialogForm.optionType == optionType.binding || this.dialogForm.optionType == optionType.unbound">
	                    <el-input v-model="dialogRowForm.zoneOfAction" disabled class="rt-input" />
	                </div>
	                <div v-else>
	                	<el-input v-model="dialogRowForm.zoneOfAction" clearable />
	                </div>
	            </el-form-item>
	            <el-form-item v-if="false" class="inline-block row-items-2" label="安全距离：" prop="safeDistance">
	                <div v-if="dialogForm.optionType == optionType.binding || this.dialogForm.optionType == optionType.unbound">
	                    <el-input v-model="dialogRowForm.safeDistance" disabled class="rt-input">
	                		<template slot="append">米</template>
	                	</el-input>
	                </div>
	                <div v-else>
	                	<el-input v-model="dialogRowForm.safeDistance" clearable>
	                		<template slot="append">米</template>
	                	</el-input>
	                </div>
	            </el-form-item>
	            <el-form-item v-if="false" class="inline-block row-items-2" label="警报地址：" prop="alarmAddr">
	                <div v-if="dialogForm.optionType == optionType.binding || this.dialogForm.optionType == optionType.unbound">
	                    <el-input v-model="dialogRowForm.alarmAddr" disabled class="rt-input"/>
	                </div>
	                <div v-else>
	                	<el-input placeholder="请输入IP" v-model="dialogRowForm.alarmAddr" clearable />
	                </div>
	            </el-form-item>
	            <el-form-item v-if="false" class="inline-block row-items-2" label="警报时长：" prop="alarmTimer">
	                <div v-if="dialogForm.optionType == optionType.binding || this.dialogForm.optionType == optionType.unbound">
	                    <el-input v-model="dialogRowForm.alarmTimer" disabled class="rt-input"/>
	                </div>
	                <div v-else>
	                	<el-input placeholder="" v-model="dialogRowForm.alarmTimer" clearable >
	                		<template slot="append">秒</template>
	                	</el-input>
	                </div>
	            </el-form-item>
				<el-form-item class="inline-block row-items-2" label="备注：" prop="remarks">
	                <div v-if="dialogForm.optionType == optionType.binding || this.dialogForm.optionType == optionType.unbound">
					    <el-input type="textarea" v-model="dialogRowForm.remarks" disabled class="rt-input"/>
	                </div>
	                <div v-else>
	                    <el-input type="textarea" v-model="dialogRowForm.remarks" clearable/>
	                </div>
				</el-form-item>
	            <el-form-item class="btn-form-item-c">
	                <el-button icon="el-icon-position" type="primary" size="primary" @click="submitForm()">{{dialogForm.submitButton}}</el-button>
	            </el-form-item>
	        </el-form>


	    </el-dialog>
    </div>
</template>

<script>
    // 交互 接口
    import ApiUser from '@/request/api-user'
    // 交互 接口
    import ApiCar from '@/request/api-car'
    // 交互 接口
    import ApiOam from '@/request/api-oam'
    // 交互 接口
    import ApiGpsTag from '@/request/api-gps-tag'
	// 组件 webSoket
	import SubWebsoket from '@/components/SubWebsoket'
	// 组件 NFC IDCard
	import NFCIDCardSub from '@/components/NFCIDCardSub'
	// ws Api
	import ApiNfcWs from '@/request/api-nfc_ws'
	// ws Api
	import TreeSelect from '@/components/TreeSingleSelect'
    import {checkEmpty} from "@/global/global-valid";

    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 2021/6/19
         */
        name: 'CarDialog',
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2021/6/19
         */
        props:{
            carGroups: Array
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/6/19
         */
        components: {
            // webSoket
            SubWebsoket,
            // 组件 NFC IDCard
			NFCIDCardSub,
            TreeSelect,
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/6/19
         */
        data() {
            return{
                /**
                 * @Des 未绑定的标签
                 * @Auth
                 * @Date 2021/6/29
                 */
                unBoundTagIds: [],

                /**
	             * @Des webSoket参数
	             * @Auth
	             * @Date 2021/7/2
	             */
	            wsFilter: {
	            	// webSoket路径
		            wsUrl: ApiNfcWs.wsUrlNfc,
		            // webSoket key
		            wsKey: '_NFC',
		            // 自动重新连接
		            autoRecreatFlag: true,
		            // 连接已打开
		            wsOnopen: this.wsOnopen,
		            // 数据推送
		            wsOnmessage: this.wsOnmessage,
		            // 无 this.wsOnmessage 时，onmessage 监听回调 {方法名称}
		            winMessageFn: null
		            // this.onMessage 与 this.wsOnmessage 存一即可
	            },

                /**
                 * @Des 弹出层属性
                 * @Auth
                 * @Date 2021/6/19
                 */
                dialogForm: {
                    title: "",
                    submitButton: '',
                    optionType: '',
                    dialogFormVisible: false,
                },
                optionType: {
                    add: 'add',
                    edit: 'edit',
                    binding: 'binding',
                    unbound: 'unbound'
                },
                /**
                 * @Des 修改表单
                 * @Auth
                 * @Date 2021/6/19
                 */
                dialogRowForm: {
                    // row 下标
                    rowIndex: -1,
                    // 当前车辆id
                    carId: '',
                    // 当前车辆组id
                    groupId: '',
                    // 当前车辆组民
                    groupName: '',
                    // 当前车辆类型
                    carType: '',
                    // 当前车牌号
                    carNumber: '',
                	// 绑定用户id
                    userId: '',
                    // 姓名
                    userName: '',
                    // 备注
                    remarks: '',
                    // 身份证号
                    idCard: '',
                    // 标签id
                    tagId: '',
                    // 作业区域
                    zoneOfAction: '',
                    // 安全距离
                    safeDistance: 5,
                    // 警报地址
                    alarmAddr: '',
                    // 警报时长
                    alarmTimer: 2,
                },
                // 查询所有车辆
                users: [],
                /**
                 * @Des 弹窗规则
                 * @Auth
                 * @Date 2021/6/19
                 */
                rules: {
                    groupId: [
                        {
                            validator: (rule, value, callback) => {
                                if(this.dialogForm.optionType != this.optionType.binding && this.dialogForm.optionType != this.optionType.unbound){
                                    if(checkEmpty(this.dialogRowForm.groupId)){
                                        new callback(new Error('请选择车辆分组'));
                                    }else{
                                        callback()
                                    }
                                }else{
                                    callback()
                                }
                            },
                        }
                    ],
                    carType: [
                        { required: true, message: '请输入车辆类型', trigger: 'blur' }
                    ],
                    carNumber: [
                        { required: true, message: '请输入车牌号', trigger: 'blur' }
                    ],
                    userId: [
                        { required: true, message: '请选择司机', trigger: 'blur' }
                    ],
                }, // rules
                /**
                 * @Des 车辆组树数据
                 * @Auth
                 * @Date 2021/6/4
                 */
                groupSelectTree:{
                    placeholder: '请选择车辆组',
                    keywordFilter: false,
                    showBox: false,
                    childBox: false,
                    parentBox: false,
                },
            }
        },
        mounted: function (){
            this.searchUsers();
        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date 2021/6/19
         */
        methods:{
            /*
	        // webSoket 数据推送   利用window监听
	        onMessage(e) {
	        	this.keyword = e.data;
	        	// 检索数据
	        	this.scanDeviceId();
	        },
	        */
	        // webSoket 数据推送   onmessage回调
	        wsOnmessage(e) {
	        	// 检索数据
	        	//this.scanDeviceId();

	        	// 标签id
				    this.dialogRowForm.tagId = e.data;
	        },

            /**
             * @Des 选择值改变
             * @Auth
             * @Date 2021/6/4
             */
            setSelectVal(val){
                if(val && val.id){
                    this.dialogRowForm.groupId = val.id;
                    this.dialogRowForm.groupName = val.label;
                    this.$refs['treeSelect'].setSelectVal(val);
                }else{
                    this.dialogRowForm.groupId = '';
                    this.dialogRowForm.groupName = '';
                    this.$refs['treeSelect'].setSelectVal();
                }
            },

            /**
             * @Des 查询所有车辆
             * @Auth
             * @Date 2021/6/19
             */
            searchUsers(){
                this.$request.postJsonRequest(ApiUser.searchUserApi,{
                    // projectId: this.$store.state.currentProjectId,
                    orderBy: {
                        userName: 'asc'
                    },
                    startNum: 0,
                    limit: 0,
                    total: 0,
                }).then(result => {
                    this.users = result.rows;
                }).catch(error => {
                    console.error('车辆导出异常', ApiUser.exportApi, error);
                });
            },

            /**
             * @Des 查询标签用户
             * @Auth
             * @Date 2021/6/19
             */
            searchTagCar(data){
            	if (!this.dialogRowForm.tagId) {
            		
					return false;
                }
            	
                if(this.dialogForm.optionType == this.optionType.unbound){
                    this.$request.postJsonRequest(ApiGpsTag.findByDidApi, {
                        did: data,
                        // projectId: this.$store.state.currentProjectId
                    }).then(result => {
                        // console.log(result)
                        if(result.code == 0){
                        	let _data = Object.assign({}, result.data);
                            let data = Object.assign({}, _data.carForm);
                            
                            // 当前用户
                            this.dialogRowForm.userId = data.userId;
                            // 姓名
                            this.dialogRowForm.userName = data.userName;
                            // 备注
                            this.dialogRowForm.remarks = data.remarks;
                            // 车辆id
                            this.dialogRowForm.carId = data.carId;
                            // 车牌号
                            this.dialogRowForm.carNumber = data.carNumber;
                            // 车辆类型
                            this.dialogRowForm.carType = data.carType;
                            // 身份证号
                            this.dialogRowForm.idCard = data.idCard;
                            // 标签id
                            this.dialogRowForm.tagId = data.tagId;
                            // 车辆组id
                            this.dialogRowForm.groupId = data.groupId;
                            // 车辆组名
                            this.dialogRowForm.groupName = data.groupName;
                            // 作业区域
                            this.dialogRowForm.zoneOfAction = data.zoneOfAction;
                            // 安全距离
                            this.dialogRowForm.safeDistance = !this.$checkEmpty(data.safeDistance) ? data.safeDistance : 5;
                            // 警报地址
                            this.dialogRowForm.alarmAddr = data.alarmAddr;
                            // 警报时长
                            this.dialogRowForm.alarmTimer = !this.$checkEmpty(data.alarmTimer) ? data.alarmTimer : 2;
                        }
                    }).catch(error => {
                        console.error('查询已绑定车辆异常', ApiGpsTag.findByDidApi, error);
                    });
                }
            },
            /**
             * @Des 查询未绑定的标签
             * @Auth
             * @Date 2021/6/19
             */
            searchTag(){
            	// ApiOam.Find_Uwb_Tag_By_Binding_Type_Uri
                this.$request.postJsonRequest(ApiGpsTag.fingByBindTypeApi,{
                    bindType: ((this.dialogForm.optionType=='add'||this.dialogForm.optionType=='binding')?0:3),
                    // projectId: this.$store.state.currentProjectId
                }).then(result => {
                	let unBoundTagIds = [];
                	Object.assign([], result.data).forEach((row, index) => {
                		if ((this.dialogForm.optionType=='add'||this.dialogForm.optionType=='binding') && row.bindType == 0) {
                			unBoundTagIds.push(Object.assign({}, row));
                		} else if (!(this.dialogForm.optionType=='add'||this.dialogForm.optionType=='binding') && row.bindType == 3) {
                			unBoundTagIds.push(Object.assign({}, row));
                		}
                	});
                	
                	this.unBoundTagIds = Object.assign([], unBoundTagIds);
                	// 未绑定的标签 Copy
                	this.unBoundTagIdsCopy = Object.assign([], unBoundTagIds);
                }).catch(error => {
                    console.error('查询标签异常', ApiGpsTag.fingByBindTypeApi, error);
                });
            },

            /**
             * @Des 打开账户弹窗
             * @Auth
             * @Date 2021/6/19
             */
            openDialog(title, button, optionType, data, rowIndex){
                // console.log(data);
                this.dialogForm.dialogFormVisible = true;
				        this.dialogForm.title = title;
                this.dialogForm.submitButton = button;
                this.dialogForm.optionType = optionType;
				
                // 重置表单
                this.reset();
                // console.log(optionType);
                if(optionType == this.optionType.add){
                    // 新增
                    this.$nextTick(function () {
                        this.searchTag();
                        if(data){
                            this.setSelectVal(data);
                        }else{
                            this.dialogRowForm.groupId = !this.$checkEmpty(this.carGroups[0]) && !this.$checkEmpty(this.carGroups[0].id) ? this.carGroups[0].id : '';
                        }
                    });
                }else if(optionType == this.optionType.edit || optionType == this.optionType.binding){
                    // 编辑 或 绑定
                    this.$nextTick(function () {
                        // 当前用户
                        this.dialogRowForm.userId = data.userId;
                        // row 下标
                        this.dialogRowForm.rowIndex = rowIndex;
                        // 姓名
                        this.dialogRowForm.userName = data.userName;
                        // 备注
                        this.dialogRowForm.remarks = data.remarks;
                        // 车辆id
                        this.dialogRowForm.carId = data.carId;
                        // 车辆分组id
                        this.dialogRowForm.groupId = data.groupId;
                        // 车牌号
                        this.dialogRowForm.carNumber = data.carNumber;
                        // 车辆类型
                        this.dialogRowForm.carType = data.carType;
                        // 身份证号
                        this.dialogRowForm.idCard = data.idCard;
                        // 标签id
                        this.dialogRowForm.tagId = data.tagId;
                        // 作业区域
                        this.dialogRowForm.zoneOfAction = data.zoneOfAction;
                        // 安全距离
                        this.dialogRowForm.safeDistance = !this.$checkEmpty(data.safeDistance) ? data.safeDistance : 5;
                        // 警报地址
                        this.dialogRowForm.alarmAddr = data.alarmAddr;
                        // 警报时长
                        this.dialogRowForm.alarmTimer = !this.$checkEmpty(data.alarmTimer) ? data.alarmTimer : 2;
                        
                        // 判断是绑定，还是编辑页面
                        if(optionType == 'binding'){
                            // 绑定
                            
                            this.dialogRowForm.groupId = data.groupId;
                            this.dialogRowForm.groupName = data.groupName;
                            
                            this.searchTag();
                        }else{
                            // 编辑
	                        let group = {
	                            id: data.groupId,
	                            label: data.groupName
	                        }
	                        this.setSelectVal(group);
                        }
                    });

                }else if(optionType == this.optionType.unbound){
                    // 解绑
                    this.searchTag();
                }

            },

            /**
             * @Des 提交账户信息
             * @Auth
             * @Date 2021/6/19
             */
            submitForm(){
                /**
                * @Des 表单校验
                * @Auth
                * @Date 2021/6/19
                */
                this.$refs.dialogRowForm.validate(valid => {
                    if(!valid) return false;

                    if(this.dialogForm.optionType == this.optionType.unbound && this.dialogRowForm.tagId == ''){
                        this.$message({
                            message: "请确认要绑定的标签",
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        return false;
                    }

                    // 交互参数
                    let params = {
                        carIds: [this.dialogRowForm.carId],
                        carId: this.dialogRowForm.carId,
                        groupId: this.dialogRowForm.groupId,
                        carType: this.dialogRowForm.carType,
                        carNumber: this.dialogRowForm.carNumber,
                        userId: this.dialogRowForm.userId,
                        tagId: this.dialogRowForm.tagId,
                        zoneOfAction: this.dialogRowForm.zoneOfAction,
                        safeDistance: !this.$checkEmpty(this.dialogRowForm.safeDistance) ? this.dialogRowForm.safeDistance : 5,
                        alarmAddr: this.dialogRowForm.alarmAddr,
                        alarmTimer: !this.$checkEmpty(this.dialogRowForm.alarmTimer) ? this.dialogRowForm.alarmTimer : 2,
                        remarks: this.dialogRowForm.remarks,
                        // projectId: this.$store.state.currentProjectId
                    };
                    // console.log(params)

                    // 交互 路径
                    let submitApi = '';
                    let successMsg = '';
                    if(this.dialogForm.optionType == this.optionType.add){
                        submitApi = ApiCar.addCarApi;
                        successMsg = '添加成功！';

                    }else if(this.dialogForm.optionType == this.optionType.edit){
                        submitApi = ApiCar.updateCarApi
                        successMsg = '编辑成功！';

                    }else if(this.dialogForm.optionType == this.optionType.binding){
                        submitApi = ApiCar.bindingCarApi;
                        successMsg = '绑定成功！';

                    }else if(this.dialogForm.optionType == this.optionType.unbound){
                        submitApi = ApiCar.unboundCarApi;
                        successMsg = '解绑成功！';
                    }


                    /**
                    * @Des 数据交互
                    * @Auth
                    * @Date 2021/6/19
                    */
                    this.$request.postJsonRequest(submitApi, params).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: successMsg,
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            if(this.dialogForm.editFlag){
                                // 刷新列表
                                this.$emit("setRow", this.dialogRowForm, this.dialogRowForm.rowIndex);
                            }else{
                                // 添加成功
                                this.$emit("setTotal", 0);
                            }
                            // 关闭弹窗
                            this.dialogForm.dialogFormVisible = false;
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                    }).catch(error => {
                        console.error('车辆信息异常', submitApi, error);
                    })
                });// validata
            },

            /**
	         * @Des 关闭弹窗
	         * @Auth
	         * @Date 2021/6/19
	         */
	        handleDialogClose(){
	        },

            /**
	         * @Des 重置方法
	         * @Auth Zhangbin
	         * @Date 17:28 2021/4/30
	         */
	        reset(){
	            // 清除表单数据
	            this.cleanData(this.dialogRowForm)
	            // 清除表单验证
	            this.cleanValidate('dialogRowForm');
	        },

            /**
             * @Des 清除验证信息
             * @Auth
             * @Date 2021/6/19
             */
            cleanValidate(formName){
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
	         * @Des 清除数据
	         * @Auth
	         * @Date 2021/6/19
	         */
	        cleanData(form){
	            // 延时执行
	            this.$nextTick(function () {
                    // row 下标
                    form.rowIndex = -1;
                    // 车辆id
                    form.carId = '';
                    // 车辆组id
                    form.groupId = '';
                    // 车辆组名
                    form.groupName = '';
                    // 车辆类型
                    form.carType = '';
                    // 车牌号
                    form.carNumber = '';
                    // 当前用户
                    form.userId = '';
                    // 姓名
                    form.userName = '';
                    // 备注
                    form.remarks = '';
                    // 身份证号
                    form.idCard = '';
                    // 标签id
                    form.tagId = '';
                    // 作业区域
                    form.zoneOfAction = '';
                    // 安全距离
                    form.safeDistance = 5;
                    // 警报地址
                    form.alarmAddr = '';
                    // 报警时长
                    // 警报地址
                    form.alarmTimer = 2;
	            });// 延时执行
	        },

        },// methods
        // 计算属性
        computed: {
        },
    }
</script>
/* JS */

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 1000px;
		
		.el-textarea__inner {
			height: 46px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components_pages/Car/CarDialog.vue